webpackJsonp([114276838955818,60335399758886],{

/***/ 107:
/***/ (function(module, exports) {

	module.exports = {"data":{"navigation":{"edges":[{"node":{"id":"c7cTDVrjZ6MIEyYKGmaeIY2","name":"Home","slug":"/","active":true,"order":0,"background":null}},{"node":{"id":"c2Gd4xTMuB2W2sWYEmKmOa2","name":"Portfolio","slug":"portfolio","active":true,"order":1,"background":null}},{"node":{"id":"c31nyWfkyLegaM0qMm0A8qW","name":"Resume","slug":"resume","active":true,"order":2,"background":null}},{"node":{"id":"c28ZpwqkCtKoqU4GUKIgkYg","name":"About","slug":"about","active":true,"order":3,"background":"#EAA427"}},{"node":{"id":"JACMkKDJaUmGUGsUgaaMM","name":"Contact","slug":"contact","active":true,"order":4,"background":null}}]},"headerBackground":{"resize":{"src":"/static/background-palm-21abb6104040e6b480b2a59fcea73851-478e8.jpeg"}}},"layoutContext":{}}

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(207);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(107);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(23);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(61);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(60);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(109);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(53);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactEmotion = __webpack_require__(17);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _logoBlack = __webpack_require__(467);
	
	var _logoBlack2 = _interopRequireDefault(_logoBlack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      logoStatus: 'spicy'
	    };
	    return _this;
	  }
	
	  Header.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    var location = this.props.location;
	    // if (location.pathname !== prevProps.location.pathname) {
	    //   if (this.props.location.pathname === '/') {
	    //     // Web animation API! (experimental)
	    //     this.header.animate([{ height: '200px' }, { height: '400px' }], {
	    //       duration: 300,
	    //       fill: 'forwards',
	    //       easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
	    //       iterations: 1,
	    //     })
	    //   } else {
	    //     this.header.animate([{ height: '400px' }, { height: '200px' }], {
	    //       duration: 300,
	    //       fill: 'forwards',
	    //       easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
	    //       iterations: 1,
	    //     })
	    //   }
	    // }
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        data = _props.data,
	        location = _props.location;
	
	    return _react2.default.createElement(
	      HeaderWrapper,
	      {
	        isHome: location.pathname === '/',
	        ref: function ref(node) {
	          return _this2.header = _reactDom2.default.findDOMNode(node);
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: header__container },
	        _react2.default.createElement(Background, { src: data.headerBackground.resize.src }),
	        _react2.default.createElement(
	          'div',
	          { className: header__text },
	          'Allexa D\'Alessio'
	        )
	      ),
	      _react2.default.createElement(
	        'nav',
	        { className: navigation },
	        data.navigation.edges.map(function (_ref) {
	          var node = _ref.node;
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              key: node.id,
	              activeClassName: navigation__active,
	              className: navigation__item,
	              to: node.slug !== '/' ? '/' + node.slug : node.slug,
	              exact: node.slug === '/'
	            },
	            node.name,
	            _react2.default.createElement(Box, { background: node.background })
	          );
	        })
	      )
	    );
	  };
	
	  return Header;
	}(_react.Component);
	
	Header.propTypes = {};
	Header.defaultProps = {};
	exports.default = Header;
	
	
	var HeaderWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eal8s4w0'
	})('text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:space-between;width:100%;position:relative;z-index:1;background-color:white;');
	var header__container = /*#__PURE__*/(0, _reactEmotion.css)('width:100%;display:flex;justify-content:center;position:relative;');
	var Background = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eal8s4w1'
	})('position:absolute;top:5px;right:5px;bottom:5px;left:5px;background-image:url(', function (_ref2) {
	  var src = _ref2.src;
	  return src;
	}, ');background-position:50% 0%;background-repeat:repeat;@media (min-width:650px){background-position:50% 100%;background-attachment:fixed;}');
	var header__text = /*#__PURE__*/(0, _reactEmotion.css)('font-family:var(--font-secondary);color:black;background:white;mix-blend-mode:screen;font-weight:700;width:100%;height:100%;text-transform:uppercase;font-size:10vw;padding:16px 0 5px 0;text-align:center;user-select:none;z-index:1;@media (min-width:650px){padding:16px 0 20px 0;}@media (min-width:1360px){font-size:8.5rem;}');
	var navigation = /*#__PURE__*/(0, _reactEmotion.css)('display:flex;justify-content:space-between;width:100%;max-width:415px;margin:0 auto 20px auto;padding:0 13% 0 13%;@media (min-width:650px){padding:0 0 0 0;}');
	var navigation__list = /*#__PURE__*/(0, _reactEmotion.css)();
	var navigation__item = /*#__PURE__*/(0, _reactEmotion.css)('display:block;padding:2px 5px 3px 6px;font-family:var(--font-secondary);font-weight:200;font-size:0.725rem;line-height:1;letter-spacing:0.05rem;text-transform:uppercase;text-decoration:none;position:relative;transition:color 0.5s ease-in-out;user-select:none;overflow:hidden;z-index:1;@media (min-width:500px){font-size:0.9rem;line-height:1.5;padding:0px 7px 1px 8px;}&:hover{color:white;div{max-width:100%;transition:max-width 0.6s ease-out;}}');
	var Box = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eal8s4w2'
	})('position:absolute;max-width:0;top:0;right:0;bottom:0;left:0;z-index:-1;transition:max-width 0.4s ease-in;background:', function (_ref3) {
	  var background = _ref3.background;
	  return background || 'black';
	}, ';');
	var navigation__active = /*#__PURE__*/(0, _reactEmotion.css)('color:white;& div{max-width:100%;}');
	module.exports = exports['default'];

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo--black.2d520349.png";

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(206);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _reactEmotion = __webpack_require__(17);
	
	__webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TemplateWrapper = function (_Component) {
	  _inherits(TemplateWrapper, _Component);
	
	  function TemplateWrapper() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TemplateWrapper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TemplateWrapper.prototype.componentDidMount = function componentDidMount() {};
	
	  TemplateWrapper.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data,
	        location = _props.location;
	
	    var pageName = function pageName() {
	      if (location.pathname !== '/') {
	        var removeSlash = location.pathname.replace('-', ' ').replace(/(.*\/|\/)/i, '');
	        var capitalized = removeSlash.split('')[0].toUpperCase();
	        var newName = [capitalized].concat(removeSlash.split('').slice(1)).join('');
	        return newName;
	      } else {
	        return 'Home';
	      }
	    };
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement('meta', { 'http-equiv': 'Content-Type', content: 'text/html;charset=UTF-8' }),
	        _react2.default.createElement('meta', {
	          name: 'viewport',
	          content: 'width=device-width, initial-scale=1.0, minimum-scale=1, maximum-scale=1'
	        }),
	        _react2.default.createElement('meta', { name: 'title', content: 'Allexa D\'Alessio' }),
	        _react2.default.createElement('meta', { name: 'description', content: 'Allexa D\'Alessio' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Allexa D\'Alessio' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'Allexa D\'Alessio' }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://allexadalessio.com' }),
	        _react2.default.createElement('meta', {
	          property: 'og:image',
	          content: 'https://images.ctfassets.net/7i8oitrgc6hc/7awjpRTea4eoQ0ge6SeOUs/7aaa89e9bd9582efa90cd58648b58671/AD5A3659-Edit.jpg?w=1200&q=95'
	        }),
	        _react2.default.createElement('meta', { property: 'og:image:width', content: '1200' }),
	        _react2.default.createElement('meta', { property: 'og:image:height', content: '630' }),
	        _react2.default.createElement('link', {
	          rel: 'stylesheet',
	          href: 'https://fonts.googleapis.com/css?family=Oswald:200,300,400,500,600,700|Roboto:300,400,500'
	        })
	      ),
	      _react2.default.createElement(_header2.default, { data: data, location: location }),
	      _react2.default.createElement(
	        'div',
	        { className: container },
	        _react2.default.createElement('div', { className: container__background }),
	        children()
	      )
	    );
	  };
	
	  return TemplateWrapper;
	}(_react.Component);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func,
	  data: _propTypes2.default.object,
	  location: _propTypes2.default.object
	};
	exports.default = TemplateWrapper;
	
	
	var container = /*#__PURE__*/(0, _reactEmotion.css)('position:relative;margin:0 auto 30px auto;');
	var container__background = /*#__PURE__*/(0, _reactEmotion.css)('position:absolute;height:30px;width:100%;left:0;right:0;top:-40px;background-image:radial-gradient( rgba(0,0,0,0.03),transparent 70%,transparent );');
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-1ff11e2d4a4fef3df183.js